
define( 'system/js/tutorial',[ 'jclass' ], function( Class ) {
	'use strict';

	/**
	 * Tutorial class
	 */

	var Tutorial = Class._extend( {

		/**
		 * Initialize the tutorial system
		 *
		 * @param {Object} aOptions
		 */

		init: function( aOptions ) {
			var options = aOptions || { };

			this._options = $.extend( true, {
				parent: null
			}, options );

			this._parent = this._options.parent;

			this._step = null;
			this._substep_index = 0;
		},

		/**
		 * Gets the app parent of the module
		 */

		getParent: function( ) {
			return this._parent;
		},

		/**
		 * Sets the current tutorial step
		 *
		 * @param {JSONObject} aStep
		 */

		setStep: function( aStep ) {
			var step = aStep || { };

			this._step = step;
			this._substep_index = 0;
		},

		/**
		 * Performs the current substep action
		 */
		substep: function( ) {
			var app = this.getParent( ),
				substep;

			if ( this._step.substeps.length > this._substep_index ) {
				substep = this._step.substeps[ this._substep_index ];

				if ( substep.type === 'callback' ) {
					if ( app._module !== null && $.isFunction( app._module[ substep.callback ] ) === true ) {
						app._module[ substep.callback ]( substep );
					}
					else {
						this._substep_index++;
						this.substep( );
					}
				}
			}
			else {
				this._step = null;
				this._substep_index = 0;
			}
		},

		/**
		 * Track the current step/substep
		 *
		 * @param {String}	aType 	The type of item to track (step|substep)
		 */
		track: function( aType ) {
			var type = aType || 'substep',
				app = this.getParent( ),
				url,
				self = this;

			url = app.getData( 'module.data.base_url' ) + 'tutorial/track/' + this._step.tutorial_id + '/' + this._step.id;

			if ( type === 'substep' ) {
				url += '/' + this._step.substeps[ this._substep_index ].id;
			}

			app.getConduit( ).ajax( {
				url: url,
				success: function( aResponse ) {
					if ( aResponse.hasOwnProperty( 'step' ) === true ) {
						if ( aResponse.step.endpoint !== self._step.endpoint ) {
							app.redirect( { href: app.getData( 'module.data.base_url' ) + aResponse.step.endpoint } );
						}
						else {
							self.setStep( aResponse.step );
							self.substep( );
						}
					}
					else {
						// Increment the substep index
						self._substep_index++;
						self.substep( );
					}
				}
			} );
		},

		/**
		 * Handles advancing the tutorial
		 */
		next: function( ) {
			this.track( );
		},


		/**
		 * Sends the tutorial back a step
		 */
		previous: function( ) {
			this._substep_index--;

			this.substep( );
		},

		/**
		 * Skips the current steps' tutorial
		 */
		skip: function( ) {
			var app = this.getParent( ),
				self = this;

			app.getConduit( ).ajax( {
				url: app.getData( 'module.data.base_url' ) + 'tutorial/skip/' + this._step.tutorial_id,
				success: function( aResponse ) {
					self._step = null;
					self._substep_index = 0;
				}
			} );
		},

		/**
		 * Show overlay
		 */
		showOverlay: function( ) {
			var body = $( 'body' ),
				overlay = $( document.createElement( 'div' ) );

			overlay.addClass( 'tutorial-overlay' );

			body.append( overlay );
		},

		/**
		 * Remove overlay
		 */
		removeOverlay: function( ) {
			var body = $( 'body' ),
				overlay = body.find( '> .tutorial-overlay' );

			overlay.remove( );
		},

		/**
		 * unload tutorial
		 */
		unload: function( ) {
			var selections = $( 'body > div.tutorial-selection' ),
				popover = $( 'body > div.popover.tutorial' );

			selections.remove( );
			popover.popover( 'destroy' );

			this.removeOverlay( );
		}
	} );

	return Tutorial;
} );

